import script from "./MineralGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./MineralGroup.vue?vue&type=script&setup=true&lang=js"

import "./MineralGroup.vue?vue&type=style&index=0&id=71e5d703&lang=css"

const __exports__ = script;

export default __exports__